import { get } from 'lodash';
import { actions } from 'Data/actions';
import checkMeetingProtection from 'Services/helpers/checkMeetingProtection';

const redirectToDashboard = (dispatch) => {
  dispatch({
    type: 'PRACTITIONER_DASHBOARD',
  });
};

const patientLoginThunk = (dispatch, getState) => {
  const currentState = getState();
  // extract the requested pageSlug
  const consultGuid = get(currentState, ['Location', 'payload', 'consult_guid']);
  dispatch(actions.meetingGetState(consultGuid));
};

const patientHasJoinedMeetingThunk = (dispatch, getState) => {
  const currentState = getState();
  const consultGuid = get(currentState, ['Location', 'payload', 'consult_guid']);
  const attendeeGuid = get(currentState, ['Location', 'payload', 'attendee_guid']);
  const hasMeeting = !!get(currentState, ['Meeting', 'chimeMeeting']);
  // check that we have meeting and attendee information
  if (hasMeeting) {
    return;
  }
  // else redirect
  dispatch({
    type: 'PATIENT_LOGIN',
    payload: {
      consult_guid: consultGuid,
      attendee_guid: attendeeGuid,
    },
  });
};

export default {
  HOME: {
    path: '/',
    thunk: redirectToDashboard,
  },
  PRACTITIONER_DASHBOARD: {
    path: '/dashboard',
    requiresAuth: true,
    requiresDevicePermission: true,
    confirmLeave: checkMeetingProtection,
    hasMeetingProtection: true,
  },
  PRACTITIONER_LOGIN: {
    path: '/login',
  },
  PRACTITIONER_REGISTER: {
    path: '/register',
  },
  PATIENT_LOGIN: {
    path: '/consults/:consult_guid/attendees/:attendee_guid',
    requiresDevicePermission: true,
    thunk: patientLoginThunk,
  },
  PATIENT_MEETING: {
    confirmLeave: checkMeetingProtection,
    hasMeetingProtection: true,
    requiresDevicePermission: true,
    path: '/consults/:consult_guid/attendees/:attendee_guid/active',
    thunk: patientHasJoinedMeetingThunk,
  },
  PATIENT_MEETING_COMPLETE: {
    path: '/consults/:consult_guid/attendees/:attendee_guid/completed',
  },
};
